import { APPLICANT_TYPE_OPTION } from '@/constant';
import {
	GetForeignProgramApplicantListResponse,
	GetForeignProgramDetailResponse,
	GetForeignProgramListResponse,
} from '@/services';
import { convertReEntryRecommendationStatus, formatDate, map } from '@/utils';

import { DefaultOptionType } from 'antd/es/select';

export const formatForeignProgramDetail = (
	input: GetForeignProgramDetailResponse
) => {
	return {
		...input,
		startDate: formatDate(input.startDate),
		endDate: formatDate(input.endDate),
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
	};
};

export const formatForeignProgramListItem = (
	input: GetForeignProgramListResponse['content'][number]
) => {
	return {
		...input,
		id: input?.programForeignId,
		programForeignStartDate: formatDate(input.programForeignStartDate),
		programForeignEndDate: formatDate(input.programForeignEndDate),
		programForeignRegistDt: formatDate(input.programForeignRegistDt),
		programForeignUpdateDt: formatDate(input.programForeignUpdateDt),
	};
};

export const formatForeignProgramList = (
	input: GetForeignProgramListResponse['content']
) => {
	return map(input, formatForeignProgramListItem);
};

export const formatForeignProgramApplicantDetail = (
	input: GetForeignProgramApplicantListResponse['content'][number]
) => {
	const applicantType = APPLICANT_TYPE_OPTION?.find(
		(e: DefaultOptionType) => e.value === input.applicantType
	);

	return {
		...input,
		applicantType: applicantType?.label || '',
		reentryRecommendationStatus: convertReEntryRecommendationStatus(
			input.reentryRecommendationStatus
		),
		birthDate: formatDate(input.birthDate),
		entryDate: formatDate(input.entryDate),
		extensionStayDate: formatDate(input.extensionStayDate),
		expirationDate: formatDate(input.expirationDate),
		departureDate: formatDate(input.departureDate),
		changeWorkDate: formatDate(input.changeWorkDate),
		unauthorizedDepartureDate: formatDate(input.unauthorizedDepartureDate),
		isReEntry: input.isReEntry ? 'O' : 'X',
		isPublic: input.isPublic ? 'O' : 'X',
		registDt: formatDate(input.registDt),
	};
};

export const formatForeignProgramApplicantList = (
	input: GetForeignProgramApplicantListResponse['content']
) => {
	return map(input, formatForeignProgramApplicantDetail);
};
